<div *ngIf="loading" style="margin-top: 32px;display: flex;justify-content: center;">
  <p-progressSpinner [style]="{ width: '40px', height: '40px' }" animationDuration=".5s">
  </p-progressSpinner>
</div>

<div class="tab-container" *ngIf="!loading">
  <div class="waiver-tab-container">
    <div *ngFor="let waiver of waivers; let i = index;" class="waiver-tab"
         [ngClass]="{'selected': waiver.productID === selectedWaiver.productID}" (click)="selectWaiver(waiver)">
      <div><span class="fa fa-check" *ngIf="waiver.waiverID && waiver.signedDate"></span>{{
        'bikeshop.rentals.booking.waiver_text' | translate }} #{{i + 1}}</div>
    </div>
  </div>
  <div class="qr-container" *ngIf="waiverUrl && waiverUrl.length>0">
    <qrcode class="waiver-qrcode" [width]="128" [qrdata]="waiverUrl" colordark="rgba(30, 30, 30, 1)"
            usesvg="true" [width]="125"></qrcode>
  </div>
</div>


<div *ngIf="selectedWaiver">

  <div class="waiver-container info-container" *ngIf="selectedWaiver && !selectedWaiver.waiverID">

    <div class="row">
<div class="col-md-9 product-title-holder">
  <div class="product-title">
    {{selectedWaiver.brand}} {{selectedWaiver.model}} {{selectedWaiver.color}} {{selectedWaiver.size}}
    {{selectedWaiver.serialNumber}}
  </div>
</div>

<div class="col-md-3">
  <div *ngIf="!busySending" class="resend-button">
    <button pButton type="button" class="p-button-raised" (click)="resendWaiver()"
    [disabled]="this.busySending"
    label="{{ 'bikeshop.rentals.booking.waiver.resend_waiver' | translate}}"></button>
  </div>
 
  <div *ngIf="busySending" style="text-align:center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="2"
        fill="transparent" animationDuration=".5s"></p-progressSpinner>
  </div>
</div>
    </div>

    <div [innerHTML]="rentalStoreRules.waiverTerms" class="waiver-terms"></div>

    <div class="row">
      <div class="col-md-2 label" [ngClass]="{'red': !selectedWaiver.customer}">{{
        'bikeshop.rentals.booking.waiver.customer' | translate }}:
      </div>
      <div class="col-md-4"><input pInputText type="text" [(ngModel)]="selectedWaiver.customer"/></div>
      <div class="col-md-2 label"
           [ngClass]="{'red': !selectedWaiver.email}">{{ 'bikeshop.rentals.booking.waiver.email'
        | translate }}:
      </div>
      <div class="col-md-4"><input pInputText type="text" [(ngModel)]="selectedWaiver.email"/></div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-2 label" [ngClass]="{'red': !selectedWaiver.birthDate}">{{
        'bikeshop.rentals.booking.waiver.date_of_birth' | translate }}:
      </div>
      <div class="col-md-4">
        <p-calendar dateFormat="{{countryData.DatePickerFormat}}" [yearNavigator]="true"
                    yearRange="1940:2023" [(ngModel)]="selectedWaiver.birthDate"></p-calendar>
      </div>
      <div class="col-md-2 label">{{ 'bikeshop.rentals.booking.waiver.is_minor' | translate }}</div>
      <div class="col-md-1">
        <p-checkbox [(ngModel)]="selectedWaiver.isMinor" [binary]="true"></p-checkbox>
      </div>
    </div>

    <div class="margin-top-16">
      <canvas #canvas class="signature-canvas" width="780" height="200">
        Canvas does not work on this browser, upgrade browser or try another
      </canvas>
    </div>

    <div class="row margin-top-16">
      <div class="col-md-4">
        <button pButton type="button" class="p-button-raised full-width alternate" (click)="clear()"
                [disabled]="!isSignatureValid() || this.submitting"
                label="{{ 'general.clear' | translate}}"></button>
      </div>
      <div class="col-md-4">
        
      </div>
        
      <div class="col-md-4">
        <button pButton type="button" class="p-button-raised" (click)="submitSignature()"
                [disabled]="!isSignatureValid() || this.submitting"
                label="{{ 'bikeshop.rentals.booking.waiver.accept_waiver' | translate}}"></button>
      </div>
    </div>
  </div>

  <div class="waiver-container info-container" *ngIf="selectedWaiver && selectedWaiver.waiverID">

    <div class="product-title">
      {{selectedWaiver.brand}} {{selectedWaiver.model}} {{selectedWaiver.color}} {{selectedWaiver.size}}
      {{selectedWaiver.serialNumber}}
    </div>

    <div [innerHTML]="selectedWaiver.waiverTerms" class="waiver-terms"></div>
    <div class="data-label margin-top-16">
      <span>{{ 'bikeshop.rentals.booking.waiver.is_minor' | translate }}: </span> {{ selectedWaiver.isMinor ?
      ('general.yes' | translate) : ('general.no' | translate) }}
    </div>
    <div class="data-label margin-top-8">
      <span>{{ 'bikeshop.rentals.booking.waiver.customer' | translate }}: </span> {{ selectedWaiver.customer }}
    </div>
    <div class="data-label">
            <span>{{ 'bikeshop.rentals.booking.waiver.date_of_birth' | translate }}
              : </span> {{ selectedWaiver.birthDate |
      date : countryData.AngularDateFormat }}
    </div>
    <div class="data-label">
      <span>{{ 'bikeshop.rentals.booking.waiver.email' | translate }}: </span> {{ selectedWaiver.email }}
    </div>
    <div class="data-label">
            <span>{{ 'bikeshop.rentals.booking.waiver.date_signed' | translate }}
              : </span> {{ selectedWaiver.signedDate | date
      :
        countryData.AngularDateFormat}}
    </div>
    <div class="waiver-signature">
      <img [src]="selectedWaiver.signatureURL">
    </div>

    <div class="row margin-top-16">
      <div class="col-md-8"></div>
      <div class="col-md-4">
        <button pButton type="button" class="p-button-raised full-width alternate" (click)="clearSignature()"
                label="{{ 'bikeshop.rentals.booking.waiver.sign_again' | translate}}"></button>
      </div>
    </div>
  </div>

</div>
